import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useMutation } from 'react-query';
import { withRouter } from 'react-router';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';

import api from 'services';
import { addNotification } from 'actions/notifications/notifications';
import { store } from 'store/configureStore';

const ArchiveLetter = ({ router, letter }) => {
    const [isPopupOpen, setPopupOpen] = useState(false);

    const archiveMutation = useMutation(
        () => api.sendLetterToArchive(letter._id),
        {
            onSuccess: (response) => {
                if (response.status) {
                    router.push('/');
                }
            },
            onError: (error) => {
                console.error('Failed to archive letter:', error);
                store.dispatch(addNotification({
                    title: 'Error',
                    message: 'Failed to send letter to archive.',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 3,
                }));
            },
        },
    );

    const handleSendToArchive = () => {
        archiveMutation.mutate();
    };

    const togglePopup = () => setPopupOpen(!isPopupOpen);

    const actions = [
        <FlatButton
            label='Cancel'
            primary
            onClick={togglePopup}
        />,
        <FlatButton
            label='Send'
            secondary
            onClick={handleSendToArchive}
            disabled={archiveMutation.isLoading}
        />,
    ];

    return (
        <div className='btn'>
            <RaisedButton
                labelStyle={{ fontSize: '10px' }}
                style={{ height: '25px' }}
                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                label={archiveMutation.isLoading ? 'Sending...' : 'Send to archive'}
                onClick={togglePopup}
                secondary
                disabled={archiveMutation.isLoading}
            />
            <Dialog
                title='Send letter to archive?'
                actions={actions}
                open={isPopupOpen}
                onRequestClose={togglePopup}
            >
                This letter will be sent to the archive.
            </Dialog>
        </div>
    );
};

export default withRouter(connect(state => ({
    letter: state.letter,
}))(ArchiveLetter));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/ArchiveLetter.jsx